"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/CampaignPage/EditPanel.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);

var _WizardFrame = require('web/screens/Broadcast/Wizard/WizardFrame');
var _Details = require('web/screens/Broadcast/Wizard/Details'); var _Details2 = _interopRequireDefault(_Details);




/* Rev 30 Z2: recipients are added from dialogs over the table, so the
 * Recipients step has no panel here. */
 const panelKindOf = (step) => {
  if (step === 'message') return 'message'
  if (step === 'details') return 'details'
  return null
}; exports.panelKindOf = panelKindOf






/* What navigating from the current panel to `target` (null: the table)
 * would lose, or null when nothing unsaved is lost: a panel's edits are lost
 * whenever it's left. */
 const leaveLoss = (
  current,
  target,
  isPanelDirty,
) =>
  isPanelDirty && current !== null && current !== target ? { lose: current } : null; exports.leaveLoss = leaveLoss








const INLINE_FRAME = { layout: 'inline' } 

/* F5: Edit details in place on the campaign page, reusing the wizard's step
 * in its inline layout. Rev 32 V1: Edit message is a dialog
 * (EditMessageDialog). */
const EditPanel = ({ campaign, onDirtyChange, onClose }) => {
  const { CampaignKey } = campaign

  const onSubmitDetails = _react.useCallback.call(void 0, 
    async (details) => {
      await _actions2.default.updateCampaign({ ...details, CampaignKey, MessageTemplate: campaign.MessageTemplate })
      onDirtyChange(false)
      _actions2.default.gotoCampaignPage(CampaignKey)
    },
    [CampaignKey, campaign.MessageTemplate, onDirtyChange],
  )

  return (
    _react2.default.createElement(_WizardFrame.StepFrameProvider, { value: INLINE_FRAME, __self: this, __source: {fileName: _jsxFileName, lineNumber: 60}}
      , _react2.default.createElement(_Details2.default, {
        campaign: campaign,
        isCreating: false,
        onCancel: onClose,
        onSubmit: onSubmitDetails,
        onDirtyChange: onDirtyChange, __self: this, __source: {fileName: _jsxFileName, lineNumber: 61}}
      )
    )
  )
}

exports. default = _react.memo.call(void 0, EditPanel)
